var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6517 9.075C18.5075 8.79727 18.2193 8.625 17.9064 8.625H12.4009L14.1882 4.15664C14.2926 3.89736 14.2607 3.60188 14.1037 3.36984C13.9466 3.13781 13.656 3 13.4064 3H7.21886C6.79593 3 6.43875 3.3131 6.38285 3.73266L5.25785 12.1702C5.22487 12.4113 5.29849 12.6539 5.45887 12.8367C5.61925 13.0195 5.85093 13.125 6.09386 13.125H11.2372L9.76839 19.9488C9.68381 20.3433 9.89035 20.742 10.2606 20.9012C10.3689 20.9789 10.4814 21 10.5939 21C10.8652 21 11.1289 20.8682 11.2903 20.633L18.6028 9.94547C18.7782 9.68672 18.7993 9.35273 18.6517 9.075ZM12.3165 16.1449L13.1065 12.4605C13.1603 12.2111 13.0977 11.9518 12.9373 11.7532C12.7771 11.5535 12.538 11.4375 12.2814 11.4375H7.0575L7.95714 4.6875H12.1618L10.3724 9.15586C10.2704 9.41602 10.3021 9.71133 10.4568 9.94336C10.6114 10.1754 10.8751 10.3125 11.1564 10.3125H16.3068L12.3165 16.1449Z",
    fill: "#002C38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBolt);
export default __webpack_public_path__ + "static/media/bolt.516e51710327e50b0b9c847d06315756.svg";
export { ForwardRef as ReactComponent };